import React from 'react'
import '../Css/styles2.css'
import '../Css/bootstrap.css'
// import '../css/animate/animate.css'
// import '../css/animate/animate.min.css'

function Services2() {
    return (
        <div id="servicess" className='main-container'>
            <div className="container-fluid services py-5 mb-5">
                <div className="container">
                    <div className="text-center mx-auto pb-5 wow fadeIn" data-wow-delay=".3s" style={{ maxWidth: '600px' }}>
                        <h5 className="text-primary">Our Services</h5>
                        <h1>Services Built Specifically For Your Business</h1>
                    </div>
                    <div className="row g-5 services-inner">
                        <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay=".3s">
                            <div className="services-item bg-light">
                                <div className="p-4 text-center services-content">
                                    <div className="services-content-icon">
                                        <i className="fa fa-code fa-7x mb-4 text-primary" />
                                        <h4 className="mb-3">Internet Of Things (IOT)</h4>
                                        <p className="mb-4">Unlocking Seamless Connectivity: Our Comprehensive Internet of Things
                                            (IoT) Services Transforming Industries and Enhancing Efficiency.</p>
                                        {/* <a href className="btn btn-secondary text-white px-5 py-3 rounded-pill">Read More</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay=".5s">
                            <div className="services-item bg-light">
                                <div className="p-4 text-center services-content">
                                    <div className="services-content-icon">
                                        <i className="fa fa-file-code fa-7x mb-4 text-primary" />
                                        <h4 className="mb-3">Web Development</h4>
                                        <p className="mb-4">Coding the Digital World: Exploring the Dynamic Realm of Web Development
                                            and Its Crucial Role in Shaping the Internet Landscape.</p>
                                        {/* <a href className="btn btn-secondary text-white px-5 py-3 rounded-pill">Read More</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay=".7s">
                            <div className="services-item bg-light">
                                <div className="p-4 text-center services-content">
                                    <div className="services-content-icon">
                                        <i className="fa fa-external-link-alt fa-7x mb-4 text-primary" />
                                        <h4 className="mb-3">UI/UX Design</h4>
                                        <p className="mb-4">Designing for Delight: The Dynamic Intersection of UI/UX for Optimal
                                            User Engagement and Satisfaction. </p>
                                        {/* <a href className="btn btn-secondary text-white px-5 py-3 rounded-pill">Read More</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay=".3s">
                            <div className="services-item bg-light">
                                <div className="p-4 text-center services-content">
                                    <div className="services-content-icon">
                                        <i className="fas fa-user-secret fa-7x mb-4 text-primary" />
                                        <h4 className="mb-3">Mobile Application</h4>
                                        <p className="mb-4">Elevate User Experiences and Boost Efficiency with Our Company's Mobile
                                            Application Service Expertise.</p>
                                        {/* <a href className="btn btn-secondary text-white px-5 py-3 rounded-pill">Read More</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay=".5s">
                            <div className="services-item bg-light">
                                <div className="p-4 text-center services-content">
                                    <div className="services-content-icon">
                                        <i className="fa fa-envelope-open fa-7x mb-4 text-primary" />
                                        <h4 className="mb-3">Digital Marketing</h4>
                                        <p className="mb-4">Comprehensive Digital Marketing Solutions Tailored to Boost Your Brand's
                                            Online Presence and Drive Results.</p>
                                        {/* <a href className="btn btn-secondary text-white px-5 py-3 rounded-pill">Read More</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay=".7s">
                            <div className="services-item bg-light">
                                <div className="p-4 text-center services-content">
                                    <div className="services-content-icon">
                                        <i className="fas fa-laptop fa-7x mb-4 text-primary" />
                                        <h4 className="mb-3">Content Creation</h4>
                                        <p className="mb-4">Elevate Your Online Presence: Expertly Crafted Content Creation
                                            Solutions for Maximum Impact and Engagement.</p>
                                        {/* <a href className="btn btn-secondary text-white px-5 py-3 rounded-pill">Read More</a> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Services2